/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-question-look-9': {
    width: 37,
    height: 57,
    viewBox: '0 0 37 57',
    data: '<path pid="0" class="st0" d="M14.5 44.9h7.7v3.3h-7.7z"/><path pid="1" class="st0" d="M33.4 37.7c0 8.3-6.8 15-15 15-8.3 0-15-6.8-15-15v-6.2c0-5.6 3.1-10.6 7.9-13.2l.5 7.4H25l.5-7.4c4.8 2.6 7.9 7.7 7.9 13.2v6.2zM23.2 3.3l-1.3 19.1h-7.2L13.4 3.3h9.8zm10.1 17.6c-1.9-2.7-4.5-4.8-7.5-6.1l1-14.7H9.9l1 14.7c-3 1.3-5.6 3.4-7.5 6.1C1.2 24 0 27.7 0 31.5v6.2C0 47.8 8.2 56 18.3 56c10.1 0 18.3-8.2 18.3-18.3v-6.2c.1-3.8-1.1-7.5-3.3-10.6"/><path pid="2" class="st0" d="M8.5 34.9h5.9v.6c0 1.6-1.3 3-3 3-1.6 0-3-1.3-3-3v-.6zm13.7 0h5.9v.6c0 1.6-1.3 3-3 3-1.6 0-3-1.3-3-3v-.6zm-17 .6c0 3.4 2.8 6.2 6.2 6.2s6.2-2.8 6.2-6.2v-.6H19v.6c0 3.4 2.8 6.2 6.2 6.2 3.4 0 6.2-2.8 6.2-6.2v-3.9H5.2v3.9z"/>'
  }
})
